import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import { uploadProducts } from 'actions/EntityActions';
import { showError } from 'actions/CommonActions';
import { readSKUMappingExcel } from 'utils/helpers';

const styles = {
    uploadButton: {
        margin: '12px',
        display: 'inline-block',
    },
    uploadInput: {
        display: 'none', // مخفی کردن input برای نمایش فقط دکمه
    },
};

class FileUploadSKUMapping extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmDialog: false,
            model: {},
            totalPriceMatch: false,
            POName: ""
        };
    }

    callback = (model) => {
        this.props.uploadProducts(model);
    }

    uploadFile = (e, callback) => {
        e.preventDefault();
        let branchId = this.props.branchId;
        try {
            let that = this;
            let productArray = [];
            readSKUMappingExcel(e.target.files[0]).then((data) => {
                try {
                    let province = data.wsname;
                    let actualData = data.data;
                    if (actualData.length > 0) {
                        actualData.forEach((item, key) => {
                            let sku = item["SKU"];
                            let name = item["Description"];
                            let size = item["Size"];
                            let category = item["Category"];
                            let subCategory = item["SubCategory"];
                            let subSubCategory = item["SubSubCategory"];
                            let brand = item["Brand"];
                            let upc = item["UPC"];
                            let caseQty = item["Case Qty"];
                            let supplier = item["Supplier"];
                            let supplierCode = item["Supplier Code"];
                            let whs = item["WHS"];
                            let provinceDefaultPrice = item[province];
                            let webName = item["Web Name"];
                            let webImage = item["Web Image"];
                            let description = item["Long Description"];
                            let lp = item["LP"];
                            let dfe = item["POS Equivalent Grams"];
                            let complianceUPC = item["Compliance UPC"];
                            let complianceCategory = item["Compliance Category"];
                            let complianceWeight = item["Compliance Weight"];
                            let thcrange = item["THC Range"];
                            let cbdrange = item["CBD Range"];
                            let thc = item["THC"];
                            let cbd = item["CBD"];
                            let depositAmount = item["DepositAmount"];

                            let model = {
                                Sku: sku ? sku.toString() || '' : '',
                                Name: name || '',
                                Size: size || '',
                                Category: category || '',
                                SubCategory: subCategory || '',
                                SubSubCategory: subSubCategory || '',
                                Brand: brand || '',
                                Upc: upc ? upc.toString() || '' : '',
                                CaseQty: !isNaN(caseQty) ? (caseQty || 0) : 0,
                                Supplier: supplier || '',
                                SupplierCode: supplierCode || '',
                                Whs: !isNaN(whs) ? (whs || 0) : 0,
                                ProvinceDefaultPrice: !isNaN(provinceDefaultPrice) ? (provinceDefaultPrice || 0) : 0,
                                WebName: webName || '',
                                WebImage: webImage || '',
                                Description: description || '',
                                Lp: lp || '',
                                Dfe: !isNaN(dfe) ? (dfe || 0) : 0,
                                ComplianceUPC: complianceUPC || '',
                                ComplianceCategory: complianceCategory || '',
                                ComplianceWeight: !isNaN(complianceWeight) ? (complianceWeight || 0) : 0,
                                ThcRange: thcrange || '',
                                CbdRange: cbdrange || '',
                                Thc: !isNaN(thc) ? (thc || 0) : 0,
                                Cbd: !isNaN(cbd) ? (cbd || 0) : 0,
                                DepositAmount: !isNaN(depositAmount) ? (depositAmount || 0) : 0
                            }
                            //only push the model if sku is not empty
                            if (sku && sku !== "") {
                                productArray.push(model);
                            }
                        });
                        let model = {
                            province,
                            branchId,
                            products: productArray
                        }
                        console.log(model);
                        callback(model);
                    } else {
                        that.props.showError("No data found in sku mapping file, please make sure you upload the file with excel format.");
                        return;
                    }
                } catch (error) {
                    console.log(error);
                    that.props.showError("product upload fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
                    return;
                }
            });
        } catch (err) {
            this.props.showError("product upload fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
            return;
        }
    }

    closeDialog = () => {
        this.setState({ confirmDialog: false });
        this.setState({ totalPriceMatch: false, POName: "", model: {} });
    }

    createPO = () => {
        this.props.model(this.state.model);
    }

    render() {
        const styles = {
            uploadButton: {
                //marginRight
            },
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                width: '50%',
                opacity: 0
            }
        };
        return (
            <Button
                label="Upload Products"
                id="uploadProductsButton"
                component="label"
                sx={styles.uploadButton}
                variant="contained"
                disabled={this.props.disabled}
            >
                Upload Products
                <input className="fileInput"
                    type="file"
                    style={styles.uploadInput}
                    onChange={(e) => this.uploadFile(e, this.callback)}
                    onClick={(e) => e.target.value = null}
                    disabled={this.props.disabled}
                />
            </Button>
        );
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        province: state.common.store.provinceState,
        branchName: state.common.store.name || '',
        purchaseOrderList: state.entity.purchaseOrderList || []
    };
}

function mapDispatchToProps(dispatch) {
    return {
        uploadProducts: (model) => dispatch(uploadProducts(model)),
        showError: (message) => dispatch(showError(message))
    }
}

export default connect(mapStatetoProps, mapDispatchToProps)(FileUploadSKUMapping);